/* CPH Luggage Premium: kurv (skuffe og kurvside). Plutonic, 2026-09-30.
   Shopify Ajax Cart API med Section Rendering: hver ændring returnerer den færdige HTML for skuffen
   (sections/cphl-cart-drawer) og kurvsiden (sections/cphl-cart), så tal, fragt og mersalg altid passer.
   Lytter på ajaxProduct:added (produktsiden og temaets egne formularer) og åbner skuffen.
   Gratis gave (snippets/cphl-gift), 2026-10-07: lægges i kurven i samme kald som varen, der giver den, så skuffen åbner
   med begge linjer. Fjernes varen, fjernes gaven i samme kald. Gaven får AppHeros linjeegenskab, så AppHero-rabatten
   sætter prisen til 0 kr. Ender en gave med en pris over 0 kr, tages den ud igen. */
(function () {
  'use strict';
  if (window.cphlCart) return;

  var DRAWER_ID = 'cphl-cart-drawer';
  var busy = 0;
  var qtyTimers = {};
  var lastFocus = null;
  var routes = (window.theme && window.theme.routes) || {};
  /* Sprogpræfiks (/en/) med i alle kald, så den engelske side får engelsk HTML tilbage */
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var URL_CHANGE = (routes.cartChange || ROOT + 'cart/change.js');
  var URL_ADD = (routes.cartAdd || ROOT + 'cart/add.js');
  var URL_UPDATE = ROOT + 'cart/update.js';
  var HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };

  function q(s, c) { return (c || document).querySelector(s); }
  function qa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function drawer() { return document.getElementById('CartDrawer'); }
  function page() { return q('[data-cphl-cart-page]'); }
  function onCartPage() { return !!page(); }
  function sectionIds() {
    var ids = [DRAWER_ID];
    var p = page();
    if (p && p.getAttribute('data-section-id')) ids.push(p.getAttribute('data-section-id'));
    return ids;
  }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  /* Sektionerne hentes fra forsiden eller kurvsiden. En produkt-URL med Accept: application/json svarer med produktets JSON i stedet. */
  function renderBase() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return onCartPage() ? (routes.cartPage || root + 'cart') : root;
  }

  function setCount(n) {
    qa('.cart-link__bubble-num').forEach(function (el) { el.textContent = n; });
    qa('.cart-link__bubble').forEach(function (el) { el.classList.toggle('cart-link__bubble--visible', n > 0); });
  }

  function apply(sections) {
    if (!sections) return;
    var d = drawer();
    var html = sections[DRAWER_ID];
    if (d && html) {
      var nd = q('#CartDrawer', parse(html));
      if (nd) {
        var region = q('[data-cart-region]', d), nregion = q('[data-cart-region]', nd);
        var scroll = region ? (q('.cphl-cd__body', region) || {}).scrollTop || 0 : 0;
        if (region && nregion) region.innerHTML = nregion.innerHTML;
        var c = q('[data-cart-count]', d), nc = q('[data-cart-count]', nd);
        if (c && nc) c.innerHTML = nc.innerHTML;
        d.setAttribute('data-count', nd.getAttribute('data-count'));
        d.classList.toggle('is-empty', nd.classList.contains('is-empty'));
        var body = q('.cphl-cd__body', d);
        if (body) body.scrollTop = scroll;
        setCount(parseInt(nd.getAttribute('data-count'), 10) || 0);
      }
    }
    var p = page();
    if (p) {
      var ph = sections[p.getAttribute('data-section-id')];
      if (ph) {
        var np = q('[data-cphl-cart-page]', parse(ph));
        if (np) {
          p.innerHTML = np.innerHTML;
          p.className = np.className;
          p.setAttribute('data-count', np.getAttribute('data-count'));
          setCount(parseInt(np.getAttribute('data-count'), 10) || 0);
        }
      }
    }
    document.dispatchEvent(new CustomEvent('cphl:cart-updated'));
  }

  function error(msg) {
    var box = q('[data-cart-error]', drawer() || document);
    if (!box) { if (msg) window.alert(msg); return; }
    box.textContent = msg || '';
    box.hidden = !msg;
    if (msg) setTimeout(function () { box.hidden = true; }, 6000);
  }

  function start() { busy++; document.documentElement.classList.add('cphl-cart-busy'); }
  function stop() { busy = Math.max(0, busy - 1); if (!busy) document.documentElement.classList.remove('cphl-cart-busy'); }
  function send(url, data) {
    return fetch(url, { method: 'POST', headers: HEADERS, body: JSON.stringify(data) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || (window.cphlT && cphlT.cart_update_failed) || 'Kurven kunne ikke opdateres'); return j; }); });
  }
  /* Med sektioner: skuffe og kurvside tegnes om. quiet: ingen fejlbesked til kunden (bruges til gaven). */
  function post(url, data, quiet) {
    data.sections = sectionIds();
    data.sections_url = renderBase();
    start();
    return send(url, data)
      .then(function (j) { apply(j.sections); return j; })
      .catch(function (e) { if (!quiet) error(e.message); refresh(); throw e; })
      .then(function (j) { stop(); return j; }, function (e) { stop(); throw e; });
  }
  /* Uden sektioner: første trin, når to kald skal ende i én omtegning. */
  function raw(url, data) {
    start();
    return send(url, data).then(function (j) { stop(); return j; }, function (e) { stop(); throw e; });
  }

  function refresh() {
    var base = renderBase();
    var u = base + (base.indexOf('?') > -1 ? '&' : '?') + 'sections=' + sectionIds().join(',');
    return fetch(u, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && (j[DRAWER_ID] !== undefined || (page() && j[page().getAttribute('data-section-id')] !== undefined))) apply(j); })
      .catch(function () {});
  }

  /* Gratis gave */
  var GIFT = null;
  try { var gcfg = document.getElementById('cphl-gift-cfg'); if (gcfg) GIFT = JSON.parse(gcfg.textContent); } catch (e) { GIFT = null; }
  if (GIFT && (!GIFT.code || !GIFT.variants || !GIFT.variants.length || !GIFT.triggers)) GIFT = null;
  var GK_OFF = 'cphl_gift_off', GK_BLOCK = 'cphl_gift_block', GK_VAR = 'cphl_gift_v';
  var giftBusy = false, giftAdds = 0, syncTimer = null;
  function store(k, v) {
    try {
      if (v === undefined) return window.sessionStorage.getItem(k);
      if (v === null) window.sessionStorage.removeItem(k); else window.sessionStorage.setItem(k, v);
    } catch (e) {}
    return null;
  }
  function isTrigger(pid) { return !!GIFT && GIFT.triggers.indexOf(String(pid)) > -1; }
  function canAuto() { return !!GIFT && store(GK_OFF) !== '1' && store(GK_BLOCK) !== '1'; }
  function giftState() {
    var el = q('[data-gift-state]', drawer() || document) || q('[data-gift-state]');
    var s = null;
    if (el) { try { s = JSON.parse(el.textContent); } catch (e) { s = null; } }
    return s || { elig: 0, have: 0, lines: [], el: [] };
  }
  function giftVariant(s) {
    var ids = GIFT.variants.map(function (v) { return v.id; });
    for (var i = 0; i < s.lines.length; i++) if (s.lines[i].own && ids.indexOf(s.lines[i].v) > -1) return s.lines[i].v;
    var pref = parseInt(store(GK_VAR), 10);
    if (pref && ids.indexOf(pref) > -1) return pref;
    return ids[0];
  }
  function giftItem(vid, qty) { return { id: vid, quantity: qty, properties: { _apphero_gift: GIFT.code } }; }
  function withGift(data, qty, s) {
    data.items.push(giftItem(giftVariant(s), qty));
    if (GIFT.campaign) data.attributes = { 'Added by': 'AppHero Free Gift', 'AppHero campaign': GIFT.campaign };
    return data;
  }
  /* Antal gaver pr. linje, så kurven har `want` gaver i alt (AppHeros egne linjer beholdes først). null: ingen ændring. */
  function giftUpdates(s, want) {
    var byKey = {}, order = [];
    s.lines.forEach(function (l) {
      if (!byKey[l.key]) { byKey[l.key] = { q: 0, own: l.own }; order.push(l.key); }
      byKey[l.key].q += l.q;
    });
    order.sort(function (a, b) { return (byKey[b].own ? 1 : 0) - (byKey[a].own ? 1 : 0); });
    var left = Math.max(0, want), upd = {}, changed = false;
    order.forEach(function (k) {
      var nq = Math.min(byKey[k].q, left);
      left -= nq;
      if (nq !== byKey[k].q) { upd[k] = nq; changed = true; }
    });
    return changed ? upd : null;
  }
  function oldQty(s, key) {
    for (var i = 0; i < s.el.length; i++) if (s.el[i].key === key) return s.el[i].q;
    return null;
  }
  /* Hvor mange gaver mangler efter et tilføj-kald (svaret fra /cart/add.js: én linje eller { items }). */
  function giftNeedAfterAdd(j) {
    if (!canAuto() || !j) return 0;
    var items = j.items ? j.items : [j];
    var s = giftState();
    var elig = s.elig;
    items.forEach(function (it) {
      if (!it || !it.key || (it.properties && it.properties._apphero_gift) || !isTrigger(it.product_id)) return;
      elig += it.quantity - (oldQty(s, it.key) || 0);
    });
    return Math.max(0, elig - s.have);
  }
  function giftRun(p) {
    giftBusy = true;
    return p.catch(function () {}).then(function () { giftBusy = false; });
  }
  function giftAdd(qty) {
    giftAdds++;
    return giftRun(post(URL_ADD, withGift({ items: [] }, qty, giftState()), true));
  }
  function scheduleSync(ms) { clearTimeout(syncTimer); syncTimer = setTimeout(giftSync, ms || 0); }
  /* Afstemmer kurven efter hver omtegning: for mange gaver tages ud, manglende lægges i, gaver med pris fjernes. */
  function giftSync() {
    if (!GIFT || giftBusy) return;
    if (busy) { scheduleSync(150); return; }
    var s = giftState();
    if (s.have > s.elig) {
      var upd = giftUpdates(s, s.elig);
      if (upd) { giftRun(post(URL_UPDATE, { updates: upd }, true)); return; }
    }
    var paid = s.lines.filter(function (l) { return l.fin > 0; });
    if (paid.length && s.have <= s.elig) {
      store(GK_BLOCK, '1');
      var off = {};
      paid.forEach(function (l) { off[l.key] = 0; });
      giftRun(post(URL_UPDATE, { updates: off }, true));
      return;
    }
    var need = s.elig - s.have;
    if (need > 0 && canAuto() && giftAdds < 3) { giftAdd(need); return; }
    var show = need > 0 && store(GK_BLOCK) !== '1';
    qa('[data-gift-offer]').forEach(function (el) { el.hidden = !show; });
  }

  function changeLine(li, qty) {
    if (!li) return;
    li.classList.add('is-busy');
    if (qty === 0) li.classList.add('is-removing');
    var key = li.getAttribute('data-key');
    var undo = function () { li.classList.remove('is-busy', 'is-removing'); };
    var s = GIFT ? giftState() : null;
    var old = s ? oldQty(s, key) : null;
    if (old !== null) {
      var elig = s.elig - old + qty;
      if (s.have > elig) {
        /* Varen, der gav gaven, tages ud eller ned: gaven følger med i samme kald. */
        var upd = giftUpdates(s, elig) || {};
        upd[key] = qty;
        return post(URL_UPDATE, { updates: upd }).catch(undo);
      }
      if (elig > s.have && canAuto()) {
        /* Flere af varen: ny gave i samme omtegning. */
        giftBusy = true;
        return raw(URL_CHANGE, { id: key, quantity: qty })
          .then(function () { giftAdds++; return post(URL_ADD, withGift({ items: [] }, elig - s.have, s), true).catch(function () {}); }, function (e) { error(e.message); undo(); refresh(); })
          .then(function () { giftBusy = false; scheduleSync(0); });
      }
    }
    return post(URL_CHANGE, { id: key, quantity: qty }).catch(undo);
  }

  function add(id, btn) {
    if (btn) btn.classList.add('is-loading');
    var data = { items: [{ id: parseInt(id, 10), quantity: 1 }] };
    var pid = btn && btn.getAttribute('data-pid');
    if (pid && isTrigger(pid) && canAuto()) {
      var s = giftState();
      var need = s.elig + 1 - s.have;
      if (need > 0) { giftAdds++; withGift(data, need, s); }
    }
    return post(URL_ADD, data)
      .then(function () { if (!onCartPage()) open(); })
      .catch(function () {})
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  function swapGift(btn) {
    var gl = btn.closest('[data-gift-line]');
    if (!gl || giftBusy) return;
    var vid = parseInt(btn.getAttribute('data-gift-swap'), 10);
    var qty = parseInt(gl.getAttribute('data-qty'), 10) || 1;
    store(GK_VAR, String(vid));
    qa('[data-gift-swap]', gl).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    var name = q('.cphl-ci__gname span', gl);
    if (name) name.textContent = btn.getAttribute('aria-label') || '';
    gl.classList.add('is-busy');
    var upd = {};
    upd[gl.getAttribute('data-key')] = 0;
    giftBusy = true;
    raw(URL_UPDATE, { updates: upd })
      .then(function () { return post(URL_ADD, { items: [giftItem(vid, qty)], attributes: GIFT.campaign ? { 'Added by': 'AppHero Free Gift', 'AppHero campaign': GIFT.campaign } : undefined }, true); })
      .catch(function () { refresh(); })
      .then(function () { giftBusy = false; scheduleSync(0); });
  }

  /* Skuffen */
  function focusables(el) {
    return qa('a[href], button:not([disabled]), input, textarea, select, [tabindex]:not([tabindex="-1"])', el).filter(function (x) { return x.offsetParent !== null; });
  }
  function open() {
    var d = drawer();
    if (!d) { window.location.href = routes.cartPage || ROOT + 'cart'; return; }
    if (d.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cphl-lock', 'cphl-cart-open');
    setTimeout(function () { var x = q('.cphl-cd__x', d); if (x) x.focus({ preventScroll: true }); }, 60);
  }
  function close() {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cphl-lock', 'cphl-cart-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* Begivenheder (delegeret, så de virker efter hver genrendering) */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var link = t.closest('[data-cart-link]');
    if (link && !onCartPage() && drawer()) { e.preventDefault(); open(); return; }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); close(); return; }
    var step = t.closest('[data-qty-step]');
    if (step) {
      var li = step.closest('[data-cart-line]');
      var input = q('[data-qty-input]', li);
      var n = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10));
      input.value = n;
      var key = li.getAttribute('data-key');
      clearTimeout(qtyTimers[key]);
      qtyTimers[key] = setTimeout(function () { changeLine(li, n); }, n === 0 ? 0 : 350);
      return;
    }
    var rm = t.closest('[data-cart-remove]');
    if (rm) {
      var line = rm.closest('[data-cart-line]');
      if (line && line.hasAttribute('data-gift-line')) store(GK_OFF, '1');
      changeLine(line, 0);
      return;
    }
    var sw = t.closest('[data-gift-swap]');
    if (sw) {
      e.preventDefault();
      if (!sw.disabled && sw.getAttribute('aria-pressed') !== 'true') swapGift(sw);
      return;
    }
    var ga = t.closest('[data-gift-add]');
    if (ga && GIFT) {
      e.preventDefault();
      store(GK_OFF, null);
      giftAdds = 0;
      ga.disabled = true;
      giftSync();
      return;
    }
    var ad = t.closest('[data-cart-add]');
    if (ad && !ad.classList.contains('is-loading')) { e.preventDefault(); add(ad.getAttribute('data-cart-add'), ad); }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-qty-input]');
    if (!input) return;
    var li = input.closest('[data-cart-line]');
    var n = Math.max(0, Math.min(99, parseInt(input.value, 10) || 0));
    if (String(n) === li.getAttribute('data-qty')) return;
    changeLine(li, n);
  });
  var noteTimer;
  document.addEventListener('input', function (e) {
    var note = e.target.closest && e.target.closest('[data-cart-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(URL_UPDATE, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ note: note.value }) }).catch(function () {});
    }, 500);
  });
  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = focusables(q('.cphl-cd__panel', d));
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  /* Lagt i kurven fra produktsiden, sættet eller finderen: mangler der en gave, lægges den i nu, og skuffen åbner med begge. */
  document.addEventListener('ajaxProduct:added', function (e) {
    var need = giftNeedAfterAdd(e.detail && e.detail.product);
    var p = need > 0 ? giftAdd(need) : refresh();
    p.then(function () { if (!onCartPage()) open(); });
  });
  document.addEventListener('cphl:cart-updated', function () { if (GIFT) scheduleSync(0); });
  document.addEventListener('cart:open', open);
  document.addEventListener('cart:close', close);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  if (GIFT) scheduleSync(400);

  window.cphlCart = { open: open, close: close, refresh: refresh, add: add, giftSync: giftSync };
})();
